const fields = [
  {
    key: 'firstName',
    type: 'input',
    templateOptions: {
      label: 'firstName'
    }
  },
  {
    key: 'lastName',
    type: 'input',
    templateOptions: {
      label: 'lastName'
    }
  },
  {
    key: 'middleName',
    type: 'input',
    templateOptions: {
      label: 'middleName'
    }
  },
  {
    key: 'email',
    type: 'input',
    templateOptions: {
      inputType: 'email',
      label: 'email'
    }
  },
  {
    key: 'birthYear',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'birthYear'
    }
  }
]

export default fields
